// Collection of features a session/agent might support, used to conditionally render UI and enable or disable feature areas.
// Only include capabilities here when they vary by provider type or agent metadata.
export interface AgentCapabilities {
    supportsDocumentUpload: boolean;
    supportsImageUpload: boolean;
    supportsBulkPromptUpload: boolean;
    supportsPersonaCustomization: boolean;
    supportsToolkit: boolean;
    supportsPromptEnhancer: boolean;
    supportsKnowledgeSources: boolean;
    supportsThinkLonger: boolean;
    hasOverview: boolean;
    supportsDownloadChatSession: boolean;
    supportsChatRenaming: boolean;
}

// By default, capabilities are disabled unless explicitly enabled.
const defaults: AgentCapabilities = {
    supportsDocumentUpload: false,
    supportsImageUpload: false,
    supportsBulkPromptUpload: false,
    supportsPersonaCustomization: false,
    supportsToolkit: false,
    supportsPromptEnhancer: false,
    supportsKnowledgeSources: false,
    supportsThinkLonger: false,
    hasOverview: false,
    supportsDownloadChatSession: false,
    supportsChatRenaming: false,
};

export const buildAgentCapabilities = (
    overrides: Partial<AgentCapabilities> = {},
): AgentCapabilities => ({ ...defaults, ...overrides });
